import {Component, ElementRef, Input, OnInit, Renderer2, ViewChild, ViewEncapsulation} from '@angular/core';
import {WorkflowService} from '../../../../services/apiServices/business/workflow-service';
import {TranslateService} from '@ngx-translate/core';
import {UserManagementService} from '../../../../services/apiServices/business/user-management.service';
import {CustomerUser} from '../../../../model/customer-user';
import {CustomerGroup} from '../../../../model/customer-group';
import {SelectItem} from 'primeng/api';
import {EmailValidator} from '../../../../model/email-validator';
import {Dropdown} from 'primeng/dropdown';
import {CommonService} from '../../../../services/apiServices/business/common.service';
import {from, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {AuthenticationService} from "../../../../services/apiServices/security/authentication.service";

/**
 * Component represented by signature and validation modal
 */
@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserManagementComponent implements OnInit {
  // @ViewChild('sUserID', { static: false } ) sUserID: ElementRef;
  // @ViewChild('sUserFirstName', { static: false } ) sUserFirstName: ElementRef;
  // @ViewChild('sUserLastName', { static: false } ) sUserLastName: ElementRef;
  // @ViewChild('sUserEmail', { static: false } ) sUserEmail: ElementRef;
  // @ViewChild('sLangId', { static: false } ) sLangId: Dropdown;
  // @ViewChild('title', { static: false } ) title: Dropdown;
  // @ViewChild('sUserPwd', { static: false } ) sUserPwd: ElementRef;
  private _sUserID: ElementRef;
  @ViewChild('sUserID', {static: false}) set sUserID(element: ElementRef) {
    if (element) {
      this._sUserID = element;
    }
  }

  get sUserID(): ElementRef {
    return this._sUserID;
  }

  private _sUserFirstName: ElementRef;
  @ViewChild('sUserFirstName', {static: false}) set sUserFirstName(element: ElementRef) {
    if (element) {
      this._sUserFirstName = element;
    }
  }

  get sUserFirstName(): ElementRef {
    return this._sUserFirstName;
  }

  private _sUserLastName: ElementRef;
  @ViewChild('sUserLastName', {static: false}) set sUserLastName(element: ElementRef) {
    if (element) {
      this._sUserLastName = element;
    }
  }

  get sUserLastName(): ElementRef {
    return this._sUserLastName;
  }

  private _sUserEmail: ElementRef;
  @ViewChild('sUserEmail', {static: false}) set sUserEmail(element: ElementRef) {
    if (element) {
      this._sUserEmail = element;
    }
  }

  get sUserEmail(): ElementRef {
    return this._sUserEmail;
  }

  private _sLangId: Dropdown;
  @ViewChild('sLangId', {static: false}) set sLangId(element: Dropdown) {
    if (element) {
      this._sLangId = element;
    }
  }

  get sLangId(): Dropdown {
    return this._sLangId;
  }

  private _title: Dropdown;
  @ViewChild('title', {static: false}) set title(element: Dropdown) {
    if (element) {
      this._title = element;
    }
  }

  get title(): Dropdown {
    return this._title;
  }

  @Input('groupList') groupList: boolean;
  userList: CustomerUser[];
  selectedGroup: CustomerGroup;
  selectedUser: CustomerUser;
  editUser: CustomerUser;
  newUser: boolean;
  duplicateId: boolean;
  duplicateIdLabel: string;
  userColumns: any[];
  pageRows: number;
  locales: SelectItem [];
  titles: SelectItem [];
  languages: any;
  userIdColumnLabel: string;
  userFirstNameColumnLabel: string;
  userLastNameColumnLabel: string;
  userEmailColumnLabel: string;
  errorMessage: string;
  selectedUserTitle: string;
  downgradeErrorMessage: string;

  /**
   * constructor that instantiate variables
   *
   * @param authenticationService
   * @param renderer
   * @param {WorkflowService} workflowService - permit httpRequest correctly formatted
   * @param commonService
   * @param userManagementService
   * @param {TranslateService} translate - handle component translation
   */
  constructor(private authenticationService: AuthenticationService, private renderer: Renderer2, private workflowService: WorkflowService, private commonService: CommonService,
              private userManagementService: UserManagementService, private translate: TranslateService) {
    this.pageRows = 10;
    this.userColumns = [];
  }

  /**
   * Affect variables
   */
  public ngOnInit(): void {
    this.languages = {
      'en_US': this.translate.instant('COMMON.LANGUAGES.LANG_EN'),
      'fr_FR': this.translate.instant('COMMON.LANGUAGES.LANG_FR')
    };
    this.locales = [
      {label: '', value: ''},
      {label: this.translate.instant('COMMON.LANGUAGES.LANG_FR'), value: 'fr_FR'},
      {label: this.translate.instant('COMMON.LANGUAGES.LANG_EN'), value: 'en_US'}
    ];
    this.titles = [
      {label: this.translate.instant('COMMON.TITLES.USER'), value: 'utilisateur'},
      {label: this.translate.instant('COMMON.TITLES.SUPERVISOR'), value: 'supervisor'}
    ];
    this.newUser = false;
    if (this.userManagementService.selectedGroup) {
      this.useGroup(this.userManagementService.selectedGroup);
    }

    this.getTradForComponent();
    this.buildColumns();

    this.userManagementService.groupSelectedEvent.subscribe(group => {
      this.selectedUser = null;
      this.useGroup(group);
    });
  }

  public useGroup(group: CustomerGroup): void {
    this.selectedGroup = group;
    this.userManagementService.getGroupUsers(this.selectedGroup.sGrpUserID).subscribe(result => {
      this.userList = result;
    });
  }

  /*
   display error message on request fail
  private displayError(errorTitle: string, errorMessage: string): void {
    this.commonService.addToast({life: 3000, severity: 'error', summary: errorTitle, detail: errorMessage});
  }
   */
  public buildColumns(): void {
    this.userColumns.push({field: 'sUserID', header: this.userIdColumnLabel});
    this.userColumns.push({field: 'sUserFirstName', header: this.userFirstNameColumnLabel});
    this.userColumns.push({field: 'sUserLastName', header: this.userLastNameColumnLabel});
    this.userColumns.push({field: 'sUserEmail', header: this.userEmailColumnLabel});
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {

    this.userIdColumnLabel = this.translate.instant('GROUP_MANAGEMENT.COMPONENT.USER_DI_LABEL');
    this.userFirstNameColumnLabel = this.translate.instant('GROUP_MANAGEMENT.COMPONENT.USER_FIRST_NAME_LABEL');
    this.userLastNameColumnLabel = this.translate.instant('GROUP_MANAGEMENT.COMPONENT.USER_LAST_NAME_LABEL');
    this.userEmailColumnLabel = this.translate.instant('GROUP_MANAGEMENT.COMPONENT.USER_EMAIL_LABEL');
    this.duplicateIdLabel = this.translate.instant('GROUP_MANAGEMENT.COMPONENT.DUPLICATE_ID_LABEL');
    this.downgradeErrorMessage = this.translate.instant("COMMON.TITLES.DOWNGRADE_FROM_SUPERVISOR_TO_USER_IMPOSSIBLE");
  }

  public handleUserSelection(selected: any) {
    this.initTitle();
    if (this.selectedUser && this.selectedUser.sUserID === selected.sUserID) {
      this.selectedUser = null;
    } else {
      this.selectedUser = selected;
      if (this.selectedUser.businessCategory) {
        this.selectedUser.adminUsers = this.selectedUser.businessCategory.indexOf("adminUsers") >= 0;
        this.selectedUser.adminExpress = this.selectedUser.businessCategory.indexOf("adminExpress") >= 0;
        this.selectedUser.adminLog = this.selectedUser.businessCategory.indexOf("adminLog") >= 0;
        this.selectedUser.adminErl = this.selectedUser.businessCategory.indexOf("adminErl") >= 0;
        this.selectedUser.adminEmail = this.selectedUser.businessCategory.indexOf("adminEmail") >= 0;
      }
      this.editUser = null;
      this.newUser = false;
    }
  }

  // Uncheck adminErl if adminExpress is unchecked
  onAdminExpressChange(isChecked: boolean) {
    if (!isChecked) {
      this.editUser.adminEmail = false;
      this.editUser.adminErl = false;
    }
  }

  public cancelEditUser(): void {
    if (!this.selectedUser) {
    }
    this.selectedUser = null;

    this.newUser = false;
  }

  public editSelectedUser(): void {
    this.editUser = this.selectedUser;
    if (this.editUser.bSupervisor) {
      this.editUser.title = 'supervisor';
    } else {
      this.editUser.title = 'utilisateur';
    }
    this.newUser = false;
    if (this.editUser.businessCategory) {
      this.editUser.adminUsers = this.editUser.businessCategory.indexOf("adminUsers") >= 0;
      this.editUser.adminExpress = this.editUser.businessCategory.indexOf("adminExpress") >= 0;
      this.editUser.adminErl = this.editUser.businessCategory.indexOf("adminErl") >= 0;
      this.editUser.adminLog = this.editUser.businessCategory.indexOf("adminLog") >= 0;
      this.editUser.adminEmail = this.editUser.businessCategory.indexOf("adminEmail") >= 0;
    }
  }

  public createNewUser(): void {
    this.editUser = new CustomerUser();
    this.editUser.sLangID = 'fr_FR';
    this.editUser.title = 'utilisateur';
    this.selectedUser = this.editUser;
    this.newUser = true;
  }

  public isAvaliableId(id: string): boolean {
    if (this.userList) {
      for (const user of this.userList) {
        if (user.sUserID === id) {
          return false;
        }
      }
    }
    return true;
  }

  validateElement(el: ElementRef, valid: boolean): boolean {
    if (valid) {
      this.renderer.removeClass(el.nativeElement, 'invalid');
      this.renderer.addClass(el.nativeElement, 'valid');
      return true;
    } else {
      this.renderer.removeClass(el.nativeElement, 'valid');
      this.renderer.addClass(el.nativeElement, 'invalid');
      return false;
    }
  }

  validateElementDD(dd: Dropdown, valid: boolean): boolean {
    if (valid) {
      this.renderer.removeClass(dd.el.nativeElement, 'invalid-dd');
      this.renderer.addClass(dd.el.nativeElement, 'valid-dd');
      return true;
    } else {
      this.renderer.removeClass(dd.el.nativeElement, 'valid-dd');
      this.renderer.addClass(dd.el.nativeElement, 'invalid-dd');
      return false;
    }
  }

  public validate() {
    let v1 = (!!this.editUser.sUserID && this.editUser.sUserID !== '');
    if (this.newUser) {
      const available = this.isAvaliableId(this.editUser.sUserID);
      this.duplicateId = !available;
      v1 = available;
      this.validateElement(this.sUserID, v1);
    }
    /*
    if (v1) {
      // v2 = this.validateElement(this.sUserPwd, (this.editUser.sUserPwd && this.editUser.sUserPwd !== ''));
    } else {
      v1 = this.validateElement(this.sUserID, v1);
      // v2 = this.validateElement(this.sUserPwd, EmailValidator.passwordIsValid(this.editUser.sUserPwd));
    }
    */

    const v3 = this.validateElementDD(this.title, (this.editUser.title && this.editUser.title !== ''));
    const v4 = this.validateElement(this.sUserFirstName, (this.editUser.sUserFirstName && this.editUser.sUserFirstName !== ''));
    const v5 = this.validateElement(this.sUserLastName, (this.editUser.sUserLastName && this.editUser.sUserLastName !== ''));
    const v6 = this.validateElement(this.sUserEmail, EmailValidator.emailIsValid(this.editUser.sUserEmail));
    const v7 = this.validateElementDD(this.sLangId, (this.editUser.sLangID && this.editUser.sLangID !== ''));

    // return v1 && v2 && v3 && v4 && v5 && v6 && v7;
    return v1 && v3 && v4 && v5 && v6 && v7;

  }

  private generateRandomPassword(): string {
    const lowers = "abcdefghijklmnopqrstuvwxyz";
    const uppers = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const digits = "0123456789";
    const specials = "@#$%^&+!*=";
    const allChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%^&+!*=";

    const getRandomChar = (str: string) => str.charAt(Math.floor(Math.random() * str.length));

    let password = getRandomChar(lowers) +
      getRandomChar(uppers) +
      getRandomChar(digits) +
      getRandomChar(specials);

    for (let i = 0; i < 8; i++) {
      password += getRandomChar(allChars);
    }

    return this.shuffle(password);
  }

  private shuffle(str: string): string {
    const arr = str.split('');
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr.join('');
  }

  private sha1Encrypt(data: string): Observable<string> {
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data);

    const hashObservable = from(crypto.subtle.digest('SHA-1', dataBuffer));
    return hashObservable.pipe(
      map(res => {
        let sUserPwd = btoa(String.fromCharCode.apply(null, new Uint8Array(res)));
        if (sUserPwd.endsWith('=')) {
          sUserPwd = sUserPwd.slice(0, -1);
        }
        return sUserPwd;
      })
    );
  }

  public saveUser(): void {
    try {
      this.errorMessage = null;
      if (this.validate()) {
        this.editUser.businessCategory = ' ';
        if (this.editUser.title !== 'utilisateur') {
          if (this.editUser.adminUsers) {
            this.editUser.businessCategory += 'adminUsers_';
          }
          if (this.editUser.adminExpress) {
            this.editUser.businessCategory += 'adminExpress_';
          }
          if (this.editUser.adminLog) {
            this.editUser.businessCategory += 'adminLog_';
          }
          if (this.editUser.adminErl) {
            this.editUser.businessCategory += 'adminErl_';
          }
          if (this.editUser.adminEmail) {
            this.editUser.businessCategory += 'adminEmail_';
          }
        }

        if (this.newUser) {
          if ((this.authenticationService.isAdminNumen() && localStorage.getItem('wsoAccessToken') != null && localStorage.getItem('wsoAccessToken').length > 0) || (localStorage.getItem('hasBeenWsoLoggedIn') === 'true' && localStorage.getItem('wsoAccessToken') != null)) {
            this.userManagementService.getWsoGroupIdByName(this.selectedGroup.sCustomerID).subscribe((groupId: string) => {
              if (groupId == null) return;
              this.userManagementService.getWsoRoleIdByName(this.editUser.title).subscribe(roleId => {
                if (roleId == null) return;
                this.userManagementService.createWsoUser(this.editUser, this.selectedGroup.sGrpUserID).subscribe(userId => {
                  if (userId == null) return;
                  this.userManagementService.addWsoUserToRole(userId, roleId).subscribe(response => {
                    if (response == null) return;
                    this.userManagementService.addWsoGroupMemberByUsername(userId, '', groupId).subscribe((success: boolean) => {
                      if (!success) {
                        return;
                      }
                        this.userManagementService.createUser(this.editUser, this.selectedGroup.sGrpUserID).subscribe((response: any) => {
                          if (response.bOK) {
                            this.userList = response.datas.users;
                            this.selectedUser = null;
                            this.newUser = false;
                            return response;
                          } else {
                            if (response.sMsgError) {
                              this.errorMessage = response.sMsgError;
                            }
                          }
                        });
                    })
                  })
                })
              })
            })
          } else {
            this.userManagementService.createUser(this.editUser, this.selectedGroup.sGrpUserID).subscribe((response: any) => {
              if (response.bOK) {
                this.userList = response.datas.users;
                this.selectedUser = null;
                this.newUser = false;
              } else {
                if (response.sMsgError) {
                  this.errorMessage = response.sMsgError;
                }
              }
            });
          }
        } else {
          if (localStorage.getItem('hasBeenWsoLoggedIn') === 'true' && localStorage.getItem('wsoAccessToken') != null) {
            if(this.editUser.sUserID == this.authenticationService.userLogged.idUser && this.editUser.title == "utilisateur"){
              this.commonService.addToast({
                life: 3000,
                severity: 'error',
                summary: 'Echec de l\'opération',
                detail: this.downgradeErrorMessage
              });
              return;
            }
            this.userManagementService.getWsoUserIdByUsername(this.editUser.sUserID).subscribe(userId => {
              if (userId == null) {
                this.updateLDAPUser();
                return
              }

              this.userManagementService.getWsoUserById(userId).subscribe(user => {
                if (user == null) return;
                this.userManagementService.updateWsoUserWithLdapUser(user, this.editUser).subscribe(response => {
                  if (response == null) return;
                  if (this.editUser.title != user.roles[0].display) {
                    this.userManagementService.removeWsoUserFromRole(user.id, user.roles[0].value).subscribe(result => {
                      if (result == null) return;
                      this.userManagementService.getWsoRoleIdByName(this.editUser.title).subscribe(roleId => {
                        if (roleId == null) return;
                        this.userManagementService.addWsoUserToRole(user.id, roleId).subscribe();
                      })
                    })
                  }
                  this.userManagementService.updateUser(this.editUser, this.selectedGroup.sGrpUserID).subscribe(response => {
                    this.userList = response.datas.users;
                    this.selectedUser = null;
                    this.newUser = false;
                  });
                })
              })
            })
          } else {
            this.updateLDAPUser()
          }
        }
      }
    } catch (e) {
      this.commonService.addToast({life: 3000, severity: 'error', summary: this.errorMessage});
    }
  }

public updateLDAPUser()
{
  this.userManagementService.updateUser(this.editUser, this.selectedGroup.sGrpUserID).subscribe(response => {
    this.userList = response.datas.users;
    this.selectedUser = null;
    this.newUser = false;
  });
}

  public initTitle(): void {
  if(this.selectedUser && this.selectedUser.bAdmin
)
{
      this.selectedUserTitle = this.translate.instant('COMMON.TITLES.SUPERVISOR');
    }
if (this.selectedUser && this.selectedUser.bSupervisor) {
      this.selectedUserTitle = this.translate.instant('COMMON.TITLES.SUPERVISOR');
} else if (this.selectedUser && !this.selectedUser.bSupervisor && !this.selectedUser.bAdmin) {
      this.selectedUserTitle = this.translate.instant('COMMON.TITLES.USER');
    }
  }
}
